import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {formatDate} from '@/utils/timeFilter'

@Component({})
export default class ApprovalCommon extends Vue {
    @Prop() logList: []
    formatDate = formatDate
    logShow = true
    logShowHistory = false
    logList2 = [{
        content: '支持使用图标',
        timestamp: '2018-04-12 20:46',
        size: 'large',
        type: 'primary',
        icon: 'el-icon-more'
    }, {
        content: '支持自定义颜色',
        timestamp: '2018-04-03 20:46',
        color: '#0bbd87'
    }, {
        content: '支持自定义尺寸',
        timestamp: '2018-04-03 20:46',
        size: 'large'
    }, {
        content: '默认样式的节点',
        timestamp: '2018-04-03 20:46'
    }]
    logList1 = []
    logListNew = []
    logListHistory = []

    created() {

        if (this.logList.length > 0) {

            this.logListNew = (this.logList as any)[0].messageReviewLogList
            const nweArr = [];
            (this.logList as any).forEach(item => {
                nweArr.push(item.messageReviewLogList)
            });
            nweArr.shift();
            nweArr.forEach(item => {
                item.forEach(items => {
                    this.logListHistory.push(items)
                })
            })

            this.setColor(this.logListNew)
            this.setColor(this.logListHistory)

        }
    }

    setColor(array) {
        array.forEach(item => {
            if (item.action.indexOf('待审批') != -1) {
                item.color = '#D3D3D3FF'
            } else if (item.action.indexOf('审批中') != -1) {
                item.icon = 'el-icon-more'
                item.color = '#0bbd87'
                item.size = 'large'
            } else if (item.action.indexOf('通过了审批') != -1) {
                item.icon = 'el-icon-success'
                item.type = 'primary'
                item.size = 'large'
            } else if (item.action.indexOf('发起了') != -1) {
                item.icon = 'el-icon-success'
                item.type = 'primary'
                item.size = 'large'
            }else if (item.action.indexOf('撤回了审批') != -1) {
                item.icon = 'el-icon-success'
                item.type = 'primary'
                item.size = 'large'
            } else if (item.action.indexOf('已通过') != -1) {
                item.icon = 'el-icon-success'
                item.type = 'primary'
                item.size = 'large'
            } else if (item.action.indexOf('已驳回') != -1) {
                item.icon = 'el-icon-error'
                item.type = 'warning'
                item.size = 'large'
                item.color = '#ff0000'
            } else {
                item.color = '#D3D3D3FF'
            }
        })
    }

//获得年月日时分秒
//传入日期//例：2020-10-27T14:36:23
    timeFormatSeconds(time) {
        if (!time) {
            return ''
        }
        const d = time ? new Date(time) : new Date();
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let day = d.getDate();
        let hours = d.getHours();
        let min = d.getMinutes();
        let seconds = d.getSeconds();

        if (month < 10) {
            (month as any) = '0' + month;
        }
        if (day < 10) (day as any) = '0' + day;
        if (hours < 0) (hours as any) = '0' + hours;
        if (min < 10) (min as any) = '0' + min;
        if (seconds < 10) (seconds as any) = '0' + seconds;

        return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
    }
    //
    // @Watch('logList')
    // watchlogList(newVal: any[], old: any[]) {
    //     console.log(newVal, old)
    // }
}
